import {
	OfferEngineType,
	type Activity,
	type Offer,
	type WidgetActivity,
	type WidgetOffer
} from '#lib/types/generated/index.js';
import type { WidgetMember } from '#lib/types/generated/widgetMember.gen.js';
import type { WidgetBookingCustomer } from '#lib/widget/booking/booking.js';

export function mapWidgetMemberToBookingCustomer(
	member: WidgetMember,
	previousCustomer?: Partial<WidgetBookingCustomer> | null
): WidgetBookingCustomer {
	return {
		id: member.id,
		firstName: member.firstName,
		lastName: member.lastName,
		email: member.email,
		phone: member.phone,
		phoneOptIn: previousCustomer?.phoneOptIn ?? member.phoneOptIn,
		emailOptIn: previousCustomer?.emailOptIn ?? member.emailOptIn,
		preferredLocale: previousCustomer?.preferredLocale || member.preferredLocale || '',
		customFields: previousCustomer?.customFields ?? {}
	};
}

export function mapWidgetActivityToActivity(wa: WidgetActivity): Activity {
	return {
		id: wa.id,
		name: wa.name,
		color: '#3B82F6',
		followAddress: false,
		address: null,
		followContact: false,
		contactEmail: null,
		contactName: null,
		contactPhone: null,
		followLogo: false,
		logo: wa.image,
		parentId: '',
		archivedAt: null
	};
}

export function mapWidgetOfferToOffer(wo: WidgetOffer): Offer {
	return {
		id: wo.id,
		name: wo.name,
		privateShortName: wo.name,
		engine: OfferEngineType.Recurrent,
		isActive: true,
		sortOrder: wo.sortOrder,
		presentation: wo.presentation ?? '',
		shortDescription: wo.shortDescription ?? '',
		color: '#10B981',
		followLogo: false,
		logo: wo.image,
		bookingTimeBefore: null,
		reconfirmTimeBefore: null,
		basePrice: wo.basePrice,
		excludeOtherOffers: false,
		isPrivate: false,
		maxDuration: null,
		maxPax: wo.maxPax,
		minPax: wo.minPax,
		maxBookingPerDay: 0,
		maxBookingPerSession: 0,
		maxFutureBookingTime: wo.maxFutureBookingTime,
		minBreakTimeBetweenSession: 0,
		validityDates: null,
		validityStart: null,
		validityEnd: null,
		publishStart: null,
		publishEnd: null,
		allowFullOnlinePayment: true,
		allowOfflinePayment: false,
		allowDeposit: false,
		cancellationTimeBefore: null,
		depositPercent: null,
		depositPrice: null,
		depositPricePerPax: null,
		dammagePercent: null,
		dammagePrice: null,
		dammagePricePerPax: null,
		dammageEnabled: false,
		depositRequiredFrom: null,
		allowGuaranteedPayment: false,
		guaranteeRequiredFrom: null,
		guaranteePercent: null,
		guaranteePricePerPax: null,
		guaranteePrice: null,
		followSessionsOrder: false,
		sessionOrders: [],
		guestPrices: [],
		collectionId: wo.collectionId,
		qrCodeEnabled: false,
		postBookingInfo: '',
		archivedAt: null
	};
}
